import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLineB = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M31 40H9C4.02944 40 0 35.9706 0 31V9C0 4.02944 4.02944 0 9 0H31C35.9706 0 40 4.02944 40 9V31C40 35.9706 35.9706 40 31 40Z",
			fill: "#3C91DC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5042 30.5747H11.7922V9.38922H19.835C23.795 9.38922 27.5169 10.4697 27.5169 14.7604C27.5169 16.9515 25.7756 18.6014 24.1257 18.9014V18.9616C26.3456 19.2616 28.2072 21.0023 28.2072 24.0033C28.2072 29.3445 23.5256 30.5747 19.5042 30.5747ZM18.7839 12.9302H16.4738V17.7915H18.844C21.3045 17.7915 22.9255 17.4013 22.9255 15.3906C22.9255 13.4407 21.4849 12.9302 18.7839 12.9302ZM18.9944 21.152H16.4738V27.0638H19.2349C22.2052 27.0638 23.3753 26.1336 23.3753 23.8831C23.3753 21.5423 21.1253 21.152 18.9944 21.152Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgLineB);
export { ForwardRef as ReactComponent };
